import { SessionContext } from "@viamap/viamap2-common";
import { useContext, useEffect } from "react"
import { MitWebsocket } from "src/common/managers/MitWebsocket"
import { ApplicationStateContext, Feature } from "src/states/ApplicationState";

export function WebsocketManager() {
   return (
      <WebsocketEnabler />
   )
}

function WebsocketEnabler() {
   const { hasAccessToFeature } = useContext(ApplicationStateContext)
   const { state: sessionState } = useContext(SessionContext)

   useEffect(() => {
      let canUseHighAccess = hasAccessToFeature(Feature.WebsocketGlobalChat)
      let user = sessionState.userRef
      MitWebsocket.getInstance(user, canUseHighAccess)

      return () => {
         MitWebsocket.closeInstance()
      }
   }, []);

   return <></>
}